import React from 'react';
import './Title.less';
import { Typography as AntdTypography } from 'antd';
import {
  bool, oneOf, func, number,
} from 'prop-types';

const Title = args => <AntdTypography.Title className="theme-title" {...args} />;

Title.propTypes = {
  code: bool,
  copyable: bool,
  delete: bool,
  disabled: bool,
  editable: bool,
  ellipsis: bool,
  level: number,
  mark: bool,
  onClick: func,
  italic: bool,
  type: oneOf(['success', 'secondary', 'warning', 'danger', 'pageTop']),
  underline: bool,
};

Title.defaultProps = {
  code: false,
  copyable: false,
  delete: false,
  disabled: false,
  editable: false,
  ellipsis: false,
  level: 1,
  mark: false,
  onClick: () => {},
  italic: false,
  type: null,
  underline: false,
};

export default Title;
